import AutoComplete from "./AutoComplete";

export const autoComplete = {
  init: (domElement) => {
    if (domElement) {
      new AutoComplete(domElement);
    }
  },
}

export default autoComplete;